







































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import {bus} from "@/plugins/bus";

@Component({})
export default class FilmBlock extends Vue {

  @Prop() film: Film.IFilm;
  @Prop() status: string;

  image: string = '';
  statuses = Film.FilmState;
  videoStarted: boolean = false;
  platform: string = null;
  widthPlayer: number = null;
  heightPlayer: number = null;
  acceptVimeoCookies = false;

  get scaleCloudStyle() {
    let coefficient  = 0;
    let result = {};
    if (this.status === this.statuses.ACTIVE) {
      let scale = +this.$store.state.rhizome.scaleCloud.toFixed(1);
      switch (scale) {
        case 0.9:
        case 0.8:
          coefficient = 3;
          break;
        case 0.7:
          coefficient = 4;
          break;
        case 0.6:
          coefficient = 8;
          break;
        case 0.5:
          coefficient = 9;
          break;
        case 0.4:
          coefficient = 10;
          break;
        case 0.3:
          coefficient = 25;
          break;
        case 0.2:
          coefficient = 40;
          break;
        case 0.1:
          coefficient = 65;
          break;
        default:
          coefficient = 0;
          break;
      }
      result = { transform : (`scale(${6 + coefficient})`)};
    }

    return result;
  }

  created() {
    this.detectOS();


    this.acceptVimeoCookies = JSON.parse(localStorage.getItem('acceptVimeoCookies'));
    bus.$on('UpdateCookieBotState', () => {
      this.acceptVimeoCookies = JSON.parse(localStorage.getItem('acceptVimeoCookies'));
    });
  }

  mounted() {
    this.image = this.film.imgPreview;
  }

  async startPlay() {
    if (!this.acceptVimeoCookies) return;
    (this.$refs.player as any).mute();
    let startTime = this.film.loop_start ? this.film.loop_start : 60;
    (this.$refs.player as any).player.setCurrentTime(startTime);
    [this.widthPlayer, this.heightPlayer] = await Promise.all([(this.$refs.player as any).player.getVideoWidth(), (this.$refs.player as any).player.getVideoHeight()]);
    (this.$refs.player as any).play();
  }

  onTimeupdate(event) {
    if (!this.acceptVimeoCookies) return;
    this.videoStarted = true;
    let startTime = this.film.loop_start ? this.film.loop_start : 60;
    let endTime = this.film.loop_end ? this.film.loop_end : 75;
    if (event.seconds < startTime || event.seconds >= endTime) {
      (this.$refs.player as any).player.setCurrentTime(startTime);
      (this.$refs.player as any).play();
    }
    (this.$refs.player as any).controls = false;
  }

  detectOS() {
    const platform = navigator.platform.toLowerCase(),
        iosPlatforms = ['iphone', 'ipad', 'ipod', 'ipod touch'];

    if (platform.includes('mac')) return this.platform = 'MacOS';
    if (iosPlatforms.includes(platform)) return this.platform = 'iOS';
    if (platform.includes('win')) return this.platform = 'Windows';
    if (/android/.test(navigator.userAgent.toLowerCase())) return this.platform =  'Android';
    if (/linux/.test(platform)) return this.platform =  'Linux';

    return this.platform = 'unknown';
  }

  @Watch('status')
  onStatusChange() {
    if (!this.acceptVimeoCookies) return;
    if (this.status === this.statuses.ACTIVE) {
      Promise.resolve()
        .then(() => {
          let img: any = new Image();
          img.addEventListener('load', e => {
            this.image = img.src;
          });
          img.src = this.film.imgLarge;
        });
    }
    else {
      this.videoStarted = false;
      this.image = this.film.imgPreview;
    }
  }
}
